// extracted by mini-css-extract-plugin
export default {"container":"style_container__OHmOp","margin-top18":"style_margin-top18__zH5O9","button-div":"style_button-div__7OzCS","square":"style_square__i+cZY"};